/* global axios */
import ApiClient from './ApiClient';

class WhatsappCampaignsAPI extends ApiClient {
  constructor() {
    super('whatsapp_campaigns', { accountScoped: true });
  }

  create(data) {
    return axios.post(this.url, { whatsapp_campaign: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { whatsapp_campaign: data });
  }

  toggle(campaignId) {
    return axios.post(`${this.url}/${campaignId}/toggle`);
  }

  restart(campaignId) {
    return axios.post(`${this.url}/${campaignId}/restart`);
  }

  retryFailed(campaignId) {
    return axios.post(`${this.url}/${campaignId}/retry_failed`);
  }

  diagnose(campaignId) {
    return axios.get(`${this.url}/${campaignId}/diagnose`);
  }

  getDeliveries(campaignId, params = {}) {
    return axios.get(`${this.url}/${campaignId}/deliveries`, { params });
  }

  deleteDelivery(campaignId, deliveryId) {
    return axios.delete(`${this.url}/${campaignId}/deliveries/${deliveryId}`);
  }

  clearDeliveriesForDate(campaignId, date) {
    return axios.delete(`${this.url}/${campaignId}/deliveries/clear_date`, {
      params: { date },
    });
  }

  generateLeads(data) {
    return axios.post(`${this.url}/generate_leads`, data);
  }

  getReplies(campaignId, params = {}) {
    return axios.get(`${this.url}/${campaignId}/replies`, { params });
  }

  exportDeliveries(campaignId, date) {
    return axios.get(`${this.url}/${campaignId}/deliveries/export`, {
      params: { date },
      responseType: 'blob',
    });
  }
}

export default new WhatsappCampaignsAPI();
